import { EFRIEND_OF_THE_MONTH_URL, STATIC__FILES_HOSTNAME } from '@/constants'
import { useMapStore } from '@/stores/useMapStore'
import type { CubeMapData } from '@/types/CubeDto'
import { computed, type Ref } from 'vue'

export function useCubeImages(cubeArg: Ref<string | null>) {
  if (!cubeArg.value || (typeof cubeArg.value === 'string' && cubeArg.value.length < 1)) {
    throw new Error('useCubeImages() called with empty cubeName.')
  }

  const cube = computed(() => {
    return useMapStore().getCubeByName(cubeArg.value!)
  })

  // Due to the fact that the reem api returns a filename that seemingly can be
  // used to generate a full url for the thumbnails but in their request to the
  // authservice which updates these urls fails to include this data, we always
  // use the urls to the original files for now, up until either reem changes
  // the api response or a service handling thumbnail generation is available.
  // TODO change this (possibly back to infoWindowImageDetails.thumbnail) when a
  // solution is available.
  const thumbnailUrl = computed(() => {
    return cube?.value?.params?.infoWindowImageDetails?.original?.url
  })

  const _iconUrl = (imgType = 'png') => {
    const cubeData: CubeMapData | null | undefined = cube?.value;
    const cubeIcon = cubeData?.icon ?? { urlBase: new URL("/app/v2/img/map-icons/efriends/", STATIC__FILES_HOSTNAME).toString(), isCustom: false, fileName: "cons-inactive-default" }
    const cubeName = cubeData?.cubeName ?? cubeArg.value!;

    const isEfriendOfTheMonth = useMapStore().isEfriendOfTheMonth(cubeName)
    if (isEfriendOfTheMonth) {
      return EFRIEND_OF_THE_MONTH_URL
    }

    if (cubeIcon.isCustom) {
      return cubeIcon.fileName
    }

    return `${cubeIcon.urlBase}${cubeIcon.fileName}.${imgType}`
  }

  const iconUrlSvg = computed(() => _iconUrl('svg'))
  const iconUrlPng = computed(() => _iconUrl('png'))

  const hasThumbnail = computed(() => !!thumbnailUrl.value)

  const imageUrl = computed(() => {
    if (cube.value) {
      return hasThumbnail.value ? thumbnailUrl.value : iconUrlSvg.value
    }

    return undefined;
  })

  return {
    iconUrlPng,
    iconUrlSvg,
    imageUrl,
    thumbnailUrl,
    hasThumbnail,
  }
}
